<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col cols="12" sm="12" md="10">
        <v-row class="pt-4">
          <v-col cols="12" sm="12" md="4">
            <v-select
              v-model="eventSlot"
              :items="eventSlots"
              clear-icon="mdi-close"
              item-text="title"
              item-value="id"
              label="Workshop"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <GradeClassStudentSelect
              @changed="gradeClassStudentChange"
              disableGradeSelect
              disableClassSelect
              :studentCol="{ cols: 12, sm: 12, md: 12 }"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-flex justify-end align-end" cols="12" sm="12" md="2">
        <v-btn class="search-button" :class="{ 'px-2': windowWidth < 1100 }" @click="onFilterChanged" outlined>
          Tìm kiếm
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import { mapGetters } from 'vuex'
import { get } from 'lodash'

export default {
  components: { GradeClassStudentSelect },
  data: () => ({
    student: '',
    eventSlot: '',
    windowWidth: window.innerWidth
  }),
  computed: {
    ...mapGetters({
      eventSlots: 'eventSlots/getItems'
    })
  },
  methods: {
    gradeClassStudentChange(data) {
      this.student = get(data, 'student.id')
    },
    onFilterChanged() {
      this.$emit('onFilterChanged', { student: this.student, eventSlot: this.eventSlot })
    },
    onResize() {
      this.windowWidth = window.innerWidth
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  }
}
</script>
